
import {
  Outlet,
  Link,
  useLocation,
  NavLink,
} from 'react-router-dom';
import React, {
  Suspense, useEffect, useState,
} from 'react';
import {
  useNavigate,
  // useSearchParams,
} from 'react-router-dom';

import { useAuth } from 'react-oidc-context';

import { motion } from 'framer-motion';

import SpeciaLogo from '../../resources/speciaLogo.png';

import { useSearchParams } from 'react-router-dom';

import SpeciaLogoWithName from '../../resources/SpeciaLogoWithName.svg';

import Cookies from 'universal-cookie';

import { ButtonBase, Button } from '@mui/material';
import PrivacyModal from './PrivacyModal';
import TermsConditionsModal from './TermsConditionsModal';

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: 'tween',
  ease: 'linear',
  duration: 0.15,
};

function LandingLayout({ tabs, digitalWorkerName, digitalWorkerDescription }) {
  const location = useLocation();

  const navigate = useNavigate();

  const auth = useAuth();

  const [
    searchParams,
    setSearchParams,
  ] = useSearchParams();
  const token = searchParams.get('token');

  const [
    status,
    setStatus,
  ] = useState(200);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    privacyPolicyModalShow,
    setPrivacyPolicyModalShow,
  ] = useState(false);

  const [
    termsConditionsModalShow,
    setTermsConditionsModalShow,
  ] = useState(false);

  const cookies = new Cookies();

  const currentPath = cookies.get('currentPath') || '/';

  useEffect(() => {
    if (auth.isAuthenticated) {
      console.log(currentPath);
      navigate(currentPath);
    }
  }, [auth.isAuthenticated]);

  return (

    <>

      <div style={{ backgroundColor: '#F5EDE5', minHeight: '100vh' }}>
        <div className="blur" style={{ backgroundColor: 'rgb(255, 255, 255, 0.9)', display: 'flex', alignItems: 'center', borderRadius: '0.5vw', position: 'sticky', top: '1vw', margin: '0 1vw' }}>
          <div style={{ flex: 1, textAlign: 'left' }}><img src={SpeciaLogoWithName} onClick={() => navigate('/landing')} style={{ width: '8vw', marginLeft: '1vw', cursor: 'pointer' }} /></div>
          <div style={{ flex: 3, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <ButtonBase onClick={() => navigate('/landing')} style={{ margin: '1vw', padding: '0.5vw 0.5vw', borderRadius: '0.4vw', fontSize: '1vw', fontWeight: '500' }}>Home</ButtonBase>
            <ButtonBase onClick={() => navigate('/landing/solutions')} style={{ margin: '1vw', padding: '0.5vw 0.5vw', borderRadius: '0.4vw', fontSize: '1vw', fontWeight: '500' }}>Solutions</ButtonBase>
            <ButtonBase onClick={() => navigate('/landing/pricing')} style={{ margin: '1vw', padding: '0.5vw 0.5vw', borderRadius: '0.4vw', fontSize: '1vw', fontWeight: '500' }}>Pricing</ButtonBase>
            <ButtonBase onClick={() => navigate('/landing/contact')} style={{ margin: '1vw', padding: '0.5vw 0.5vw', borderRadius: '0.4vw', fontSize: '1vw', fontWeight: '500' }}>Contact</ButtonBase>
          </div>
          <div style={{ flex: 1, textAlign: 'right' }}>
            <Button
              onClick={() => { auth.signinRedirect(); }}
              variant="outlined"
              style={{ flex: 1, marginRight: '1vw',
                borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.4vw 1.2vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1B685F, #1B685F)', borderRadius: '0.4vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.06vw',
              }}
            >
              Sign In
            </Button>

          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: '0', textAlign: 'center', alignItems: 'center' }}>

          <Suspense>
            <motion.div
              key={location.pathname}
              initial="initial"
              animate="in"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Outlet />
            </motion.div>
          </Suspense>
        </div>

        <footer style={{ display: 'flex', flexDirection: 'column', fontSize: '1vw', marginTop: '8vw', textAlign: 'center' }} id="colophon">

          <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', marginBottom: '1vw' }}>

            <ButtonBase onClick={() => navigate('/landing/solutions')} style={{ padding: '0.5vw', fontWeight: '500', margin: '0.5vw', borderRadius: '0.4vw' }}>Solutions</ButtonBase>
            <ButtonBase onClick={() => navigate('/landing/pricing')} style={{ padding: '0.5vw', fontWeight: '500', margin: '0.5vw', borderRadius: '0.4vw' }}>Pricing</ButtonBase>
            <ButtonBase onClick={() => navigate('/landing/contact')} style={{ padding: '0.5vw', fontWeight: '500', margin: '0.5vw', borderRadius: '0.4vw' }}>Contact Us</ButtonBase>
          </div>

          <div style={{ marginBottom: '3vw' }}>
            © 2025 Specia | All Rights Reserved |
            <a onClick={() => { setPrivacyPolicyModalShow(true); }} style={{ color: '#1c6c6c', cursor: 'pointer' }} underline="always">Privacy Policy</a>
            {' '}
            |
            <a onClick={() => { setTermsConditionsModalShow(true); }} style={{ color: '#1c6c6c', cursor: 'pointer' }} underline="always">Terms & Conditions</a>
          </div>

          <div style={{ height: '12vw', overflow: 'hidden' }} className="huge-circle">
            <img style={{ width: '30vw' }} src={SpeciaLogo} alt="Specia" />
          </div>

        </footer>
      </div>

      <PrivacyModal show={privacyPolicyModalShow} onClose={() => { setPrivacyPolicyModalShow(false); }} />

      <TermsConditionsModal show={termsConditionsModalShow} onClose={() => { setTermsConditionsModalShow(false); }} />

    </>

  );
}

export default LandingLayout;
